/*------------------------------------------------------------------------------
   About      : HTTP client for UNAUTHENTICATED CMS (Strapi) endpoints.

                Unlike CMSApiClient, this client never attaches an
                Authorization header and hits full URLs directly, so it can be
                used before login (forgot-password) or with a one-time email
                code (reset-password). Base host is the CMS server URL.

   Copyright (c) 2026 Bidgely. All rights reserved.
------------------------------------------------------------------------------*/

import { RunContextApp }            from "../RCApp"
import axios, { AxiosInstance }     from "axios"
import { API_TIMEOUT }              from "../../constants/global"
import { ErrorUtils }               from "framework/utility/ErrorUtils"

export class NoAuthAPIClient {

  private axiosClient : AxiosInstance

  constructor(private rc : RunContextApp, private serverUrl : string) {
    this.axiosClient = axios.create({
      timeout: API_TIMEOUT.DEFAULT
    })
  }

  async forgotPassword(email : string) {

    const url = `${this.serverUrl}/auth/forgot-password`

    try {

      const resp = await this.axiosClient.post(url, {
        email
      }, {
        headers: { 'Content-Type': 'application/json' }
      })

      return { data : resp.data }

    } catch (error) {

      this.rc.error(this.rc.getName(this),
        `Error >> POST request to : ${url}\n` +
        `\nresulted in error : \n`, error)

      return {
        error : ErrorUtils.getApiErrorInfo(error)
      }
    }
  }

  async resetPassword(code : string, password : string, passwordConfirmation : string) {

    const url = `${this.serverUrl}/auth/reset-password`

    try {

      const resp = await this.axiosClient.post(url, {
        code,
        password,
        passwordConfirmation
      }, {
        headers: { 'Content-Type': 'application/json' }
      })

      return { data : resp.data }

    } catch (error) {

      this.rc.error(this.rc.getName(this),
        `Error >> POST request to : ${url}\n` +
        `\nresulted in error : \n`, error)

      return {
        error : ErrorUtils.getApiErrorInfo(error)
      }
    }
  }
}
